import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "as-matches",
  ref: "scrollComponent"
}
const _hoisted_2 = { class: "as-league_title" }
const _hoisted_3 = { class: "as-match__item" }
const _hoisted_4 = { class: "as-match__time" }
const _hoisted_5 = { class: "as-match__teams" }
const _hoisted_6 = { class: "as-match__team as-match__team--home" }
const _hoisted_7 = { class: "as-match__team--name as-match__team-home-name" }
const _hoisted_8 = { class: "as-match__team as-match__team--away" }
const _hoisted_9 = { class: "as-match__team--name as-match__team-away-name" }
const _hoisted_10 = { class: "as-match__play" }
const _hoisted_11 = { class: "as-match__round" }

import { computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";
interface IProps {
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MatchsSkeleton',
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
      return _createElementVNode("div", {
        key: index,
        class: "as-competition-wrapper"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SkeletonLoader, {
            width: "30px",
            height: "30px",
            mode: "circle",
            line: 1
          }),
          _createVNode(SkeletonLoader, {
            width: "130px",
            height: "20px",
            line: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SkeletonLoader, {
              width: "100px",
              height: "20px",
              line: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(SkeletonLoader, {
                width: "40px",
                height: "40px",
                mode: "circle",
                line: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(SkeletonLoader, {
                  width: "120px",
                  height: "20px",
                  line: 1
                })
              ])
            ]),
            _createVNode(SkeletonLoader, {
              width: "40px",
              height: "40px",
              line: 1
            }),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(SkeletonLoader, {
                width: "40px",
                height: "40px",
                mode: "circle",
                line: 1
              }),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(SkeletonLoader, {
                  width: "120px",
                  height: "20px",
                  line: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(SkeletonLoader, {
              width: "40px",
              height: "40px",
              line: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(SkeletonLoader, {
              width: "100px",
              height: "20px",
              line: 1
            })
          ])
        ])
      ])
    }), 64))
  ], 512))
}
}

})